module.exports = __webpack_public_path__ + "img/fwzc.5ac55327.png";